module.exports = __webpack_public_path__ + "assets/SAMSUNG_25_5_ikony_sft_KR_ready-01.aa63d429.svg";